export default __webpack_public_path__ + "static/media/wallpaper_bg6.e5400d43.png";